exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "time-chart {\n  width: 100%;\n  padding-bottom: 3em;\n}\ntime-chart .time-chart-data-excessive {\n  display: block;\n  text-align: center;\n}\ntime-chart .time-chart-data-excessive > span {\n  display: inline-block;\n  margin: 1em;\n  padding: 0 3em;\n  border: solid 1px #67b2e8;\n  text-align: center;\n  line-height: 1.5;\n  background: #ffffff;\n  color: #67b2e8;\n  border-radius: .5em;\n}\n", ""]);

// exports
